var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.1953 95.4912C77.77 95.4912 96.0703 77.1908 96.0703 54.6162C96.0703 32.0416 77.77 13.7412 55.1953 13.7412C32.6207 13.7412 14.3203 32.0416 14.3203 54.6162C14.3203 77.1908 32.6207 95.4912 55.1953 95.4912Z",
    stroke: "#FF8E00",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2563 61.1888L52.2807 37.0605H59.1099L58.1343 61.1888H53.2563ZM55.6953 74.0605C54.5246 74.0605 53.5652 73.6567 52.8173 72.8491C52.0693 72.0414 51.6953 71.0487 51.6953 69.8709C51.6953 68.6931 52.0693 67.7004 52.8173 66.8927C53.5652 66.0851 54.5246 65.6813 55.6953 65.6813C56.866 65.6813 57.8254 66.0851 58.5734 66.8927C59.3213 67.7004 59.6953 68.6931 59.6953 69.8709C59.6953 71.0487 59.3213 72.0414 58.5734 72.8491C57.8254 73.6567 56.866 74.0605 55.6953 74.0605Z",
    fill: "#FF8E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorInfo);
export default __webpack_public_path__ + "static/media/error-info.df9344c6859d0a6f45476f321edbae1e.svg";
export { ForwardRef as ReactComponent };